import clsx from 'clsx';
import React from 'react';
import { useWindowSize } from 'usehooks-ts';

import { getImgxSrc } from '../../utils/images';
import { Button, Divider } from '../BaseUI';
import styles from './styles.module.scss';

const BULLET_POINTS = [
  {
    header: 'Expertly reported, impactful journalism',
    description:
      'Our team breaks the biggest stories in the tech world, making sure you’re up to date on everything happening in Silicon Valley and beyond.',
  },
  {
    header: 'Access to private subscriber events',
    description:
      'Stay ahead of competitors with news and analysis by attending intimate conversations with powerful executives and changemakers.',
  },
  {
    header: 'Connect with potential clients, partners and talent',
    description:
      'Dig into the behind-the-scenes and directly connect with leaders at the most important technology and finance companies in the world through our Directory and Org Charts.',
  },
  {
    header: 'Simplified billing and account management',
    description:
      'One invoice and renewal date for all of your users to make administration simple, handled by a dedicated team so you can focus on the work.',
  },
];

const MiddleSection = () => {
  const { width: windowWidth } = useWindowSize();

  return (
    <div className={styles.middleContainer}>
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <div className={styles.middleHeaderContainer}>
              <p className={styles.middleHeader}>
                Empower your teams to stay ahead of market trends with the most trusted tech
                journalism. Get group access to insider scoops on upcoming IPOs and startups, deep
                insights on the biggest tech competitors and more.
              </p>
              <p className={clsx(styles.middleHeader, styles.lastParagraph)}>
                Discounted subscription pricing based on group size.
              </p>
            </div>
          </div>
        </div>
        {windowWidth < 980 && (
          <div className="row">
            <div className="col-sm-12">{windowWidth < 980 && <Divider />}</div>
          </div>
        )}
        <div className={clsx(styles.middleWrapper, 'row')}>
          <div className="col-sm-12 col-md-6">
            {BULLET_POINTS.map((point) => (
              <div className={styles.item} key={point.header}>
                <div className={styles.itemHeader}>{point.header}</div>
                <div className={styles.itemDescription}>{point.description}</div>
              </div>
            ))}
            <div className={styles.inqueryBtn}>
              <Button variant="primary" href="#topContainer" width="full">
                INQUIRE TODAY
              </Button>
            </div>
          </div>
          <div className="col-sm-12 col-md-6">
            <div className={styles.middleImgContainer}>
              {windowWidth > 980 ? (
                <img src={getImgxSrc('/corporate/DesktopPhoneDiagram.png', true)} />
              ) : (
                <img src={getImgxSrc('/corporate/MobilePhoneDiagram.png', true)} />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MiddleSection;
